// extracted by css-extract-rspack-plugin
export default {"editorContainer":"F8kMK","iconContainer":"pi1p8","button":"tblv_","buttonHidden":"jx8fF","buttonResponding":"lOYhe","sendIcon":"HWLny","stopIcon":"mzyb7","contentWrapper":"mXPFs"};